import React from 'react';

const Left = () => (
  <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.84167 1.60029L5.66667 0.425293L0.666667 5.42529L5.66667 10.4253L6.84167 9.25029L3.025 5.42529L6.84167 1.60029Z" fill="black" fillOpacity="0.87"/>
  </svg>
);

export default Left;